import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { Receipt, FlightTakeoff } from '@mui/icons-material';
import { COLORS } from '../../settings/themeSettings';

const FacturationNouvelleHub = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f9fafb', minHeight: '100vh' }}>
            <Box sx={{ maxWidth: 900, mx: 'auto' }}>
                
                {/* Clean, Flat Header */}
                <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#111827', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Receipt color="action" />
                            Nouvelle Facture
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5 }}>
                            Sélectionnez le type de facturation à créer.
                        </Typography>
                    </Box>
                    <Button 
                        variant="outlined" 
                        onClick={() => navigate(-1)} 
                        sx={{ textTransform: 'none', borderColor: '#d1d5db', color: '#374151' }}
                    >
                        Retour
                    </Button>
                </Box>

                {/* Flat Option Cards */}
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined" sx={{ p: 3, height: '100%', borderRadius: '8px', borderColor: '#e5e7eb', display: 'flex', flexDirection: 'column' }}>
                            <Stack spacing={2} sx={{ mb: 3 }}>
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    <FlightTakeoff sx={{ color: COLORS.secondary }} />
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#111827' }}>
                                        Billetterie
                                    </Typography>
                                </Stack>

                                <Typography variant="body2" sx={{ color: '#6b7280', lineHeight: 1.6 }}>
                                    Création d’une facture de services de billetterie (billets d'avion, frais de modification, paiements clients associés).
                                </Typography>
                            </Stack>

                            <Box sx={{ flexGrow: 1 }} />

                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => navigate('/facturation/nouvelle/billetterie')}
                                sx={{ textTransform: 'none', fontWeight: 600 }}
                                fullWidth
                            >
                                Créer une facture billetterie
                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined" sx={{ p: 3, height: '100%', borderRadius: '8px', borderColor: '#e5e7eb', display: 'flex', flexDirection: 'column' }}>
                            <Stack spacing={2} sx={{ mb: 3 }}>
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    <Receipt sx={{ color: COLORS.primary }} />
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#111827' }}>
                                        Dossier Tourisme
                                    </Typography>
                                </Stack>

                                <Typography variant="body2" sx={{ color: '#6b7280', lineHeight: 1.6 }}>
                                    Création d’une facture récapitulative pour un dossier tourisme complet (circuits, séjours, prestations et règlements).
                                </Typography>
                            </Stack>

                            <Box sx={{ flexGrow: 1 }} />

                            <Button
                                variant="contained"
                                onClick={() => navigate('/facturation/nouvelle/dossier')}
                                sx={{ backgroundColor: COLORS.primary, textTransform: 'none', fontWeight: 600 }}
                                fullWidth
                            >
                                Créer une facture dossier
                            </Button>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default FacturationNouvelleHub;
